// source: public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_api_httpbody_pb = require('./google/api/httpbody_pb.js');
goog.object.extend(proto, google_api_httpbody_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var annotations_pb = require('./annotations_pb.js');
goog.object.extend(proto, annotations_pb);
var api_pb = require('./api_pb.js');
goog.object.extend(proto, api_pb);
goog.exportSymbol('proto.org.couchers.public.GetDonationStatsRes', null, global);
goog.exportSymbol('proto.org.couchers.public.GetPublicUserReq', null, global);
goog.exportSymbol('proto.org.couchers.public.GetPublicUserRes', null, global);
goog.exportSymbol('proto.org.couchers.public.GetPublicUserRes.ProfileCase', null, global);
goog.exportSymbol('proto.org.couchers.public.GetSignupPageInfoRes', null, global);
goog.exportSymbol('proto.org.couchers.public.GetVolunteersRes', null, global);
goog.exportSymbol('proto.org.couchers.public.LimitedUser', null, global);
goog.exportSymbol('proto.org.couchers.public.MostUser', null, global);
goog.exportSymbol('proto.org.couchers.public.Volunteer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.GetPublicUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.public.GetPublicUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.GetPublicUserReq.displayName = 'proto.org.couchers.public.GetPublicUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.LimitedUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.public.LimitedUser.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.public.LimitedUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.LimitedUser.displayName = 'proto.org.couchers.public.LimitedUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.MostUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.public.MostUser.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.public.MostUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.MostUser.displayName = 'proto.org.couchers.public.MostUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.GetPublicUserRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.couchers.public.GetPublicUserRes.oneofGroups_);
};
goog.inherits(proto.org.couchers.public.GetPublicUserRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.GetPublicUserRes.displayName = 'proto.org.couchers.public.GetPublicUserRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.GetSignupPageInfoRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.public.GetSignupPageInfoRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.GetSignupPageInfoRes.displayName = 'proto.org.couchers.public.GetSignupPageInfoRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.Volunteer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.public.Volunteer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.Volunteer.displayName = 'proto.org.couchers.public.Volunteer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.GetVolunteersRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.couchers.public.GetVolunteersRes.repeatedFields_, null);
};
goog.inherits(proto.org.couchers.public.GetVolunteersRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.GetVolunteersRes.displayName = 'proto.org.couchers.public.GetVolunteersRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.couchers.public.GetDonationStatsRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.couchers.public.GetDonationStatsRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.couchers.public.GetDonationStatsRes.displayName = 'proto.org.couchers.public.GetDonationStatsRes';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.GetPublicUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.GetPublicUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.GetPublicUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetPublicUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.GetPublicUserReq}
 */
proto.org.couchers.public.GetPublicUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.GetPublicUserReq;
  return proto.org.couchers.public.GetPublicUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.GetPublicUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.GetPublicUserReq}
 */
proto.org.couchers.public.GetPublicUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.GetPublicUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.GetPublicUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.GetPublicUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetPublicUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user = 1;
 * @return {string}
 */
proto.org.couchers.public.GetPublicUserReq.prototype.getUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.GetPublicUserReq} returns this
 */
proto.org.couchers.public.GetPublicUserReq.prototype.setUser = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.public.LimitedUser.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.LimitedUser.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.LimitedUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.LimitedUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.LimitedUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    city: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hometown: jspb.Message.getFieldWithDefault(msg, 4, ""),
    numReferences: jspb.Message.getFieldWithDefault(msg, 5, 0),
    joined: (f = msg.getJoined()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    hostingStatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    meetupStatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    badgesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.LimitedUser}
 */
proto.org.couchers.public.LimitedUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.LimitedUser;
  return proto.org.couchers.public.LimitedUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.LimitedUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.LimitedUser}
 */
proto.org.couchers.public.LimitedUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHometown(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumReferences(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJoined(value);
      break;
    case 7:
      var value = /** @type {!proto.org.couchers.api.core.HostingStatus} */ (reader.readEnum());
      msg.setHostingStatus(value);
      break;
    case 8:
      var value = /** @type {!proto.org.couchers.api.core.MeetupStatus} */ (reader.readEnum());
      msg.setMeetupStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addBadges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.LimitedUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.LimitedUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.LimitedUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.LimitedUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHometown();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNumReferences();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getJoined();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHostingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getMeetupStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getBadgesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.org.couchers.public.LimitedUser.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.couchers.public.LimitedUser.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string city = 3;
 * @return {string}
 */
proto.org.couchers.public.LimitedUser.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string hometown = 4;
 * @return {string}
 */
proto.org.couchers.public.LimitedUser.prototype.getHometown = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setHometown = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 num_references = 5;
 * @return {number}
 */
proto.org.couchers.public.LimitedUser.prototype.getNumReferences = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setNumReferences = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp joined = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.public.LimitedUser.prototype.getJoined = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
*/
proto.org.couchers.public.LimitedUser.prototype.setJoined = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.clearJoined = function() {
  return this.setJoined(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.LimitedUser.prototype.hasJoined = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional org.couchers.api.core.HostingStatus hosting_status = 7;
 * @return {!proto.org.couchers.api.core.HostingStatus}
 */
proto.org.couchers.public.LimitedUser.prototype.getHostingStatus = function() {
  return /** @type {!proto.org.couchers.api.core.HostingStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.couchers.api.core.HostingStatus} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setHostingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional org.couchers.api.core.MeetupStatus meetup_status = 8;
 * @return {!proto.org.couchers.api.core.MeetupStatus}
 */
proto.org.couchers.public.LimitedUser.prototype.getMeetupStatus = function() {
  return /** @type {!proto.org.couchers.api.core.MeetupStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.org.couchers.api.core.MeetupStatus} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setMeetupStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated string badges = 9;
 * @return {!Array<string>}
 */
proto.org.couchers.public.LimitedUser.prototype.getBadgesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.setBadgesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.addBadges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.LimitedUser} returns this
 */
proto.org.couchers.public.LimitedUser.prototype.clearBadgesList = function() {
  return this.setBadgesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.public.MostUser.repeatedFields_ = [18,19,22,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.MostUser.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.MostUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.MostUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.MostUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    city: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hometown: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    numReferences: jspb.Message.getFieldWithDefault(msg, 6, 0),
    gender: jspb.Message.getFieldWithDefault(msg, 7, ""),
    pronouns: jspb.Message.getFieldWithDefault(msg, 8, ""),
    age: jspb.Message.getFieldWithDefault(msg, 9, 0),
    joined: (f = msg.getJoined()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastActive: (f = msg.getLastActive()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    hostingStatus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    meetupStatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    occupation: jspb.Message.getFieldWithDefault(msg, 14, ""),
    education: jspb.Message.getFieldWithDefault(msg, 15, ""),
    aboutMe: jspb.Message.getFieldWithDefault(msg, 16, ""),
    thingsILike: jspb.Message.getFieldWithDefault(msg, 17, ""),
    regionsVisitedList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    regionsLivedList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    avatarUrl: jspb.Message.getFieldWithDefault(msg, 20, ""),
    avatarThumbnailUrl: jspb.Message.getFieldWithDefault(msg, 21, ""),
    languageAbilitiesList: jspb.Message.toObjectList(msg.getLanguageAbilitiesList(),
    api_pb.LanguageAbility.toObject, includeInstance),
    badgesList: (f = jspb.Message.getRepeatedField(msg, 23)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.MostUser}
 */
proto.org.couchers.public.MostUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.MostUser;
  return proto.org.couchers.public.MostUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.MostUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.MostUser}
 */
proto.org.couchers.public.MostUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHometown(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumReferences(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGender(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPronouns(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAge(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJoined(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastActive(value);
      break;
    case 12:
      var value = /** @type {!proto.org.couchers.api.core.HostingStatus} */ (reader.readEnum());
      msg.setHostingStatus(value);
      break;
    case 13:
      var value = /** @type {!proto.org.couchers.api.core.MeetupStatus} */ (reader.readEnum());
      msg.setMeetupStatus(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setEducation(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAboutMe(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setThingsILike(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addRegionsVisited(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addRegionsLived(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarUrl(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarThumbnailUrl(value);
      break;
    case 22:
      var value = new api_pb.LanguageAbility;
      reader.readMessage(value,api_pb.LanguageAbility.deserializeBinaryFromReader);
      msg.addLanguageAbilities(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.addBadges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.MostUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.MostUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.MostUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.MostUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHometown();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNumReferences();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getGender();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPronouns();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAge();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getJoined();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastActive();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHostingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getMeetupStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getEducation();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAboutMe();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getThingsILike();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getRegionsVisitedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getRegionsLivedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getAvatarThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getLanguageAbilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      api_pb.LanguageAbility.serializeBinaryToWriter
    );
  }
  f = message.getBadgesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      23,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string city = 3;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string hometown = 4;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getHometown = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setHometown = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string timezone = 5;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 num_references = 6;
 * @return {number}
 */
proto.org.couchers.public.MostUser.prototype.getNumReferences = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setNumReferences = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string gender = 7;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setGender = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string pronouns = 8;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getPronouns = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setPronouns = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 age = 9;
 * @return {number}
 */
proto.org.couchers.public.MostUser.prototype.getAge = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setAge = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp joined = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.public.MostUser.prototype.getJoined = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.public.MostUser} returns this
*/
proto.org.couchers.public.MostUser.prototype.setJoined = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearJoined = function() {
  return this.setJoined(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.MostUser.prototype.hasJoined = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp last_active = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.public.MostUser.prototype.getLastActive = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.public.MostUser} returns this
*/
proto.org.couchers.public.MostUser.prototype.setLastActive = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearLastActive = function() {
  return this.setLastActive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.MostUser.prototype.hasLastActive = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional org.couchers.api.core.HostingStatus hosting_status = 12;
 * @return {!proto.org.couchers.api.core.HostingStatus}
 */
proto.org.couchers.public.MostUser.prototype.getHostingStatus = function() {
  return /** @type {!proto.org.couchers.api.core.HostingStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.org.couchers.api.core.HostingStatus} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setHostingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional org.couchers.api.core.MeetupStatus meetup_status = 13;
 * @return {!proto.org.couchers.api.core.MeetupStatus}
 */
proto.org.couchers.public.MostUser.prototype.getMeetupStatus = function() {
  return /** @type {!proto.org.couchers.api.core.MeetupStatus} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.org.couchers.api.core.MeetupStatus} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setMeetupStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string occupation = 14;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string education = 15;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getEducation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setEducation = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string about_me = 16;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getAboutMe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setAboutMe = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string things_i_like = 17;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getThingsILike = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setThingsILike = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * repeated string regions_visited = 18;
 * @return {!Array<string>}
 */
proto.org.couchers.public.MostUser.prototype.getRegionsVisitedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setRegionsVisitedList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.addRegionsVisited = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearRegionsVisitedList = function() {
  return this.setRegionsVisitedList([]);
};


/**
 * repeated string regions_lived = 19;
 * @return {!Array<string>}
 */
proto.org.couchers.public.MostUser.prototype.getRegionsLivedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setRegionsLivedList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.addRegionsLived = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearRegionsLivedList = function() {
  return this.setRegionsLivedList([]);
};


/**
 * optional string avatar_url = 20;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string avatar_thumbnail_url = 21;
 * @return {string}
 */
proto.org.couchers.public.MostUser.prototype.getAvatarThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setAvatarThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * repeated org.couchers.api.core.LanguageAbility language_abilities = 22;
 * @return {!Array<!proto.org.couchers.api.core.LanguageAbility>}
 */
proto.org.couchers.public.MostUser.prototype.getLanguageAbilitiesList = function() {
  return /** @type{!Array<!proto.org.couchers.api.core.LanguageAbility>} */ (
    jspb.Message.getRepeatedWrapperField(this, api_pb.LanguageAbility, 22));
};


/**
 * @param {!Array<!proto.org.couchers.api.core.LanguageAbility>} value
 * @return {!proto.org.couchers.public.MostUser} returns this
*/
proto.org.couchers.public.MostUser.prototype.setLanguageAbilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.org.couchers.api.core.LanguageAbility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.api.core.LanguageAbility}
 */
proto.org.couchers.public.MostUser.prototype.addLanguageAbilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.org.couchers.api.core.LanguageAbility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearLanguageAbilitiesList = function() {
  return this.setLanguageAbilitiesList([]);
};


/**
 * repeated string badges = 23;
 * @return {!Array<string>}
 */
proto.org.couchers.public.MostUser.prototype.getBadgesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 23));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.setBadgesList = function(value) {
  return jspb.Message.setField(this, 23, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.addBadges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 23, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.MostUser} returns this
 */
proto.org.couchers.public.MostUser.prototype.clearBadgesList = function() {
  return this.setBadgesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.couchers.public.GetPublicUserRes.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.org.couchers.public.GetPublicUserRes.ProfileCase = {
  PROFILE_NOT_SET: 0,
  LIMITED_USER: 1,
  MOST_USER: 2,
  FULL_USER: 3
};

/**
 * @return {proto.org.couchers.public.GetPublicUserRes.ProfileCase}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.getProfileCase = function() {
  return /** @type {proto.org.couchers.public.GetPublicUserRes.ProfileCase} */(jspb.Message.computeOneofCase(this, proto.org.couchers.public.GetPublicUserRes.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.GetPublicUserRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.GetPublicUserRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetPublicUserRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    limitedUser: (f = msg.getLimitedUser()) && proto.org.couchers.public.LimitedUser.toObject(includeInstance, f),
    mostUser: (f = msg.getMostUser()) && proto.org.couchers.public.MostUser.toObject(includeInstance, f),
    fullUser: (f = msg.getFullUser()) && api_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.GetPublicUserRes}
 */
proto.org.couchers.public.GetPublicUserRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.GetPublicUserRes;
  return proto.org.couchers.public.GetPublicUserRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.GetPublicUserRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.GetPublicUserRes}
 */
proto.org.couchers.public.GetPublicUserRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.public.LimitedUser;
      reader.readMessage(value,proto.org.couchers.public.LimitedUser.deserializeBinaryFromReader);
      msg.setLimitedUser(value);
      break;
    case 2:
      var value = new proto.org.couchers.public.MostUser;
      reader.readMessage(value,proto.org.couchers.public.MostUser.deserializeBinaryFromReader);
      msg.setMostUser(value);
      break;
    case 3:
      var value = new api_pb.User;
      reader.readMessage(value,api_pb.User.deserializeBinaryFromReader);
      msg.setFullUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.GetPublicUserRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.GetPublicUserRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetPublicUserRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimitedUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.couchers.public.LimitedUser.serializeBinaryToWriter
    );
  }
  f = message.getMostUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.couchers.public.MostUser.serializeBinaryToWriter
    );
  }
  f = message.getFullUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      api_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional LimitedUser limited_user = 1;
 * @return {?proto.org.couchers.public.LimitedUser}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.getLimitedUser = function() {
  return /** @type{?proto.org.couchers.public.LimitedUser} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.public.LimitedUser, 1));
};


/**
 * @param {?proto.org.couchers.public.LimitedUser|undefined} value
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
*/
proto.org.couchers.public.GetPublicUserRes.prototype.setLimitedUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.couchers.public.GetPublicUserRes.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
 */
proto.org.couchers.public.GetPublicUserRes.prototype.clearLimitedUser = function() {
  return this.setLimitedUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.hasLimitedUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MostUser most_user = 2;
 * @return {?proto.org.couchers.public.MostUser}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.getMostUser = function() {
  return /** @type{?proto.org.couchers.public.MostUser} */ (
    jspb.Message.getWrapperField(this, proto.org.couchers.public.MostUser, 2));
};


/**
 * @param {?proto.org.couchers.public.MostUser|undefined} value
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
*/
proto.org.couchers.public.GetPublicUserRes.prototype.setMostUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.org.couchers.public.GetPublicUserRes.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
 */
proto.org.couchers.public.GetPublicUserRes.prototype.clearMostUser = function() {
  return this.setMostUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.hasMostUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional org.couchers.api.core.User full_user = 3;
 * @return {?proto.org.couchers.api.core.User}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.getFullUser = function() {
  return /** @type{?proto.org.couchers.api.core.User} */ (
    jspb.Message.getWrapperField(this, api_pb.User, 3));
};


/**
 * @param {?proto.org.couchers.api.core.User|undefined} value
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
*/
proto.org.couchers.public.GetPublicUserRes.prototype.setFullUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.org.couchers.public.GetPublicUserRes.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.GetPublicUserRes} returns this
 */
proto.org.couchers.public.GetPublicUserRes.prototype.clearFullUser = function() {
  return this.setFullUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.GetPublicUserRes.prototype.hasFullUser = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.GetSignupPageInfoRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.GetSignupPageInfoRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetSignupPageInfoRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    lastSignup: (f = msg.getLastSignup()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    lastLocation: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes}
 */
proto.org.couchers.public.GetSignupPageInfoRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.GetSignupPageInfoRes;
  return proto.org.couchers.public.GetSignupPageInfoRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.GetSignupPageInfoRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes}
 */
proto.org.couchers.public.GetSignupPageInfoRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSignup(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastLocation(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.GetSignupPageInfoRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.GetSignupPageInfoRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetSignupPageInfoRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastSignup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastLocation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserCount();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp last_signup = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.getLastSignup = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes} returns this
*/
proto.org.couchers.public.GetSignupPageInfoRes.prototype.setLastSignup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes} returns this
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.clearLastSignup = function() {
  return this.setLastSignup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.hasLastSignup = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string last_location = 2;
 * @return {string}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.getLastLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes} returns this
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.setLastLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 user_count = 3;
 * @return {number}
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.getUserCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.GetSignupPageInfoRes} returns this
 */
proto.org.couchers.public.GetSignupPageInfoRes.prototype.setUserCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.Volunteer.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.Volunteer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.Volunteer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.Volunteer.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isBoardMember: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    role: jspb.Message.getFieldWithDefault(msg, 4, ""),
    location: jspb.Message.getFieldWithDefault(msg, 5, ""),
    img: jspb.Message.getFieldWithDefault(msg, 6, ""),
    linkType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    linkText: jspb.Message.getFieldWithDefault(msg, 8, ""),
    linkUrl: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.Volunteer}
 */
proto.org.couchers.public.Volunteer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.Volunteer;
  return proto.org.couchers.public.Volunteer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.Volunteer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.Volunteer}
 */
proto.org.couchers.public.Volunteer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBoardMember(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setImg(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkText(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.Volunteer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.Volunteer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.Volunteer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.Volunteer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsBoardMember();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getImg();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLinkType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLinkText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLinkUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_board_member = 3;
 * @return {boolean}
 */
proto.org.couchers.public.Volunteer.prototype.getIsBoardMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setIsBoardMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string role = 4;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string location = 5;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string img = 6;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setImg = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string link_type = 7;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getLinkType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setLinkType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string link_text = 8;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getLinkText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setLinkText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string link_url = 9;
 * @return {string}
 */
proto.org.couchers.public.Volunteer.prototype.getLinkUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.couchers.public.Volunteer} returns this
 */
proto.org.couchers.public.Volunteer.prototype.setLinkUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.couchers.public.GetVolunteersRes.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.GetVolunteersRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.GetVolunteersRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetVolunteersRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentVolunteersList: jspb.Message.toObjectList(msg.getCurrentVolunteersList(),
    proto.org.couchers.public.Volunteer.toObject, includeInstance),
    pastVolunteersList: jspb.Message.toObjectList(msg.getPastVolunteersList(),
    proto.org.couchers.public.Volunteer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.GetVolunteersRes}
 */
proto.org.couchers.public.GetVolunteersRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.GetVolunteersRes;
  return proto.org.couchers.public.GetVolunteersRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.GetVolunteersRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.GetVolunteersRes}
 */
proto.org.couchers.public.GetVolunteersRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.couchers.public.Volunteer;
      reader.readMessage(value,proto.org.couchers.public.Volunteer.deserializeBinaryFromReader);
      msg.addCurrentVolunteers(value);
      break;
    case 2:
      var value = new proto.org.couchers.public.Volunteer;
      reader.readMessage(value,proto.org.couchers.public.Volunteer.deserializeBinaryFromReader);
      msg.addPastVolunteers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.GetVolunteersRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.GetVolunteersRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetVolunteersRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentVolunteersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.couchers.public.Volunteer.serializeBinaryToWriter
    );
  }
  f = message.getPastVolunteersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.org.couchers.public.Volunteer.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Volunteer current_volunteers = 1;
 * @return {!Array<!proto.org.couchers.public.Volunteer>}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.getCurrentVolunteersList = function() {
  return /** @type{!Array<!proto.org.couchers.public.Volunteer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.public.Volunteer, 1));
};


/**
 * @param {!Array<!proto.org.couchers.public.Volunteer>} value
 * @return {!proto.org.couchers.public.GetVolunteersRes} returns this
*/
proto.org.couchers.public.GetVolunteersRes.prototype.setCurrentVolunteersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.couchers.public.Volunteer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.Volunteer}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.addCurrentVolunteers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.couchers.public.Volunteer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.GetVolunteersRes} returns this
 */
proto.org.couchers.public.GetVolunteersRes.prototype.clearCurrentVolunteersList = function() {
  return this.setCurrentVolunteersList([]);
};


/**
 * repeated Volunteer past_volunteers = 2;
 * @return {!Array<!proto.org.couchers.public.Volunteer>}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.getPastVolunteersList = function() {
  return /** @type{!Array<!proto.org.couchers.public.Volunteer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.couchers.public.Volunteer, 2));
};


/**
 * @param {!Array<!proto.org.couchers.public.Volunteer>} value
 * @return {!proto.org.couchers.public.GetVolunteersRes} returns this
*/
proto.org.couchers.public.GetVolunteersRes.prototype.setPastVolunteersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.org.couchers.public.Volunteer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.couchers.public.Volunteer}
 */
proto.org.couchers.public.GetVolunteersRes.prototype.addPastVolunteers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.org.couchers.public.Volunteer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.couchers.public.GetVolunteersRes} returns this
 */
proto.org.couchers.public.GetVolunteersRes.prototype.clearPastVolunteersList = function() {
  return this.setPastVolunteersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.toObject = function(opt_includeInstance) {
  return proto.org.couchers.public.GetDonationStatsRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.couchers.public.GetDonationStatsRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetDonationStatsRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalDonatedYtd: jspb.Message.getFieldWithDefault(msg, 1, 0),
    goal: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.couchers.public.GetDonationStatsRes}
 */
proto.org.couchers.public.GetDonationStatsRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.couchers.public.GetDonationStatsRes;
  return proto.org.couchers.public.GetDonationStatsRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.couchers.public.GetDonationStatsRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.couchers.public.GetDonationStatsRes}
 */
proto.org.couchers.public.GetDonationStatsRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalDonatedYtd(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setGoal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.couchers.public.GetDonationStatsRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.couchers.public.GetDonationStatsRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.couchers.public.GetDonationStatsRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalDonatedYtd();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getGoal();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 total_donated_ytd = 1;
 * @return {number}
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.getTotalDonatedYtd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.GetDonationStatsRes} returns this
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.setTotalDonatedYtd = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 goal = 2;
 * @return {number}
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.getGoal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.couchers.public.GetDonationStatsRes} returns this
 */
proto.org.couchers.public.GetDonationStatsRes.prototype.setGoal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.org.couchers.public);
